import React, { useContext, useState, useEffect, memo } from 'react'
import {Collapse} from 'react-collapse'
import { isArray } from 'lodash';
import { SET_FILTERS_LIST, SET_SELECTIONS, SET_SEARCH_TERMS }from '../../../actions/actionTypes.js';
import { SearchContext } from '../../../context/context.jsx'

import Checkbox from '../Checkbox/Checkbox.jsx'
import ClubOffers from './ClubOffers.jsx'
import Search from './Search.jsx'
import PrivateDining from './PrivateDining.jsx'
import Selections from './Selections.jsx'


const Section = ({ filtersId, title, type }) => {
  const [context, dispatch] = useContext(SearchContext)
  const [opened, setOpened] = useState(false)
  const { searchTerm, searchType, filters, selections } = context

  const list = filters[filtersId].list
  const apiField = filters[filtersId].apiField
  const defaultCondition = 	filters[filtersId].defaultCondition

  useEffect(() => {
    setOpened(filters[filtersId].opened)
  }, [])

  const toggleCollapse = () => {
    setOpened(!opened)
  }

  const updateList = ( item, listFromLocalState = false, clubOffers = null ) => {

    if ( listFromLocalState ) {
      dispatch({
        type: SET_FILTERS_LIST,
        payload: {
          [filtersId]: {
            list: listFromLocalState,
          },
        },
      })
      return
    }

    if ( clubOffers ) {
      dispatch({
        type: SET_FILTERS_LIST,
        payload: {
          [filtersId]: {
            list: clubOffers.list,
            anyMeal: clubOffers.anyMeal,
            clubOffersOnly: clubOffers.clubOffersOnly,
          },
        },
      })
      return
    }

    if ( !list || !isArray(list) ) return
    const newList = list.map(listItem => {
      if ( listItem.name === item.name ) {
        return {
          ...listItem,
          active: item.active,
        }
      } else {
        return listItem
      }
    })
    dispatch({
      type: SET_FILTERS_LIST,
      payload: {
        [filtersId]: {
          list: newList,
        },
      },
    })
  }

  const updateSelection = (data, action = 'add' ) => {
    dispatch({
      type: SET_SELECTIONS,
      payload: {
        data,
        filtersId,
        action,
      },
    })
  }


  const updateSearchTerms = (data, action = 'add' ) => {
    dispatch({
      type: SET_SEARCH_TERMS,
      payload: {
        data,
        filtersId,
        action,
      },
    })
  }

  const clearSelections = e => {
    e.preventDefault()
    updateSelection([], 'clearAll')
  }

  let newSelections = []


  if ( selections ) {
    newSelections = [...selections]

    if ( searchTerm ) {
      newSelections.unshift({text: searchTerm})
    }
  }

  return (
    <div className={`c-searchSection c-searchSection--${filtersId}`}>
      <div className="c-searchSection__header d-flex justify-content-between">
        <h4 className="c-searchSection__title">
          {title}
          {
            ( type === 'selections') && (
              <span className="c-searchSection__selectionApplied"> ({`${newSelections.length} applied`})</span>
            )
          }
        </h4>
        {
          type === 'selections' ? (
            <a className="c-searchSection__clearAll" href="#" onClick={clearSelections}>Clear all</a>
          ) : (
            <div className={`c-searchSection__toggleButton c-searchSection__toggleButton--${opened ? 'opened' : 'closed'}`}
              onClick={toggleCollapse}
            />
          )
        }
      </div>
      <Collapse isOpened={opened}>
        <div className="c-searchSection__body">
          {
            type === 'selections' && (
              <Selections
                updateList={updateList}
                dispatch={dispatch}
                updateSelection={updateSelection}
                selections={newSelections}
                updateSearchTerms={updateSearchTerms}
              />
            )
          }
          {
            type === 'checkboxes' && (
              !!list.length && list.map((item, index) => {
                return (
                  <Checkbox
                    key={index}
                    item={item}
                    filtersId={filtersId}
                    updateList={updateList}
                    updateSelection={updateSelection}
                    apiField={apiField}
                    defaultCondition={defaultCondition}
                  />
                )
              })
            )
          }
          {
            type === 'clubOffers' && (
              <ClubOffers
                updateList={updateList}
                filtersId={filtersId}
                updateSelection={updateSelection}
                filters={filters[filtersId]}
              />
            )
          }
          {
            type === 'search' && (
              <Search
                updateSearchTerms={updateSearchTerms}
                searchTerm={searchTerm}
                searchType={searchType}
              />
            )
          }
          {
            type === 'slider' && (
              <PrivateDining
                updateList={updateList}
                filtersId={filtersId}
                updateSelection={updateSelection}
                filters={filters[filtersId]}
              />
            )
          }
        </div>
      </Collapse>
    </div>
  )
}

function propsAreEqual(prev, next) {
  return prev.filters === next.filters && prev.selections === next.selections
}

export default memo(Section, propsAreEqual);
